import { ProfileScreen } from '~/user/components/profile-screen/ProfileScreen';

export default ProfileScreen;
